import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { cancelled, put } from 'redux-saga/effects';

import * as D from '../../deps';
import { search } from '../../services';
import { getTypesForSearchScope } from '../../utils';

const CancelToken = axios.CancelToken;

export function* getSearchResults({ payload }) {
  const searchTypes = getTypesForSearchScope(payload.searchFilter);
  const source = CancelToken.source();
  const searchData = Object.assign(
    {},
    payload,
    { searchTypes, query: payload.searchTerm },
    { cancelToken: source.token },
  );
  if (isEmpty(searchData.query)) return;
  try {
    return yield D.tryCall(search, searchData);
  } finally {
    if (yield cancelled()) {
      source.cancel('cancelled');
    }
  }
}

export function* closeSearch({ payload: { pathname } }) {
  if (!D.isInSearchPath(pathname)) {
    yield put(D.Actions.UseCases.closeSearch());
  }
}
